import './Home.css';
import { useEffect } from 'react';

const DEVELOPER = 'MS Technologies Limited';
const DEVELOPER_URL = 'https://play.google.com/store/apps/dev?id=8660687290148324751';
const CONTACT_EMAIL = 'name6007@gmail.com';
// Google's official "Get it on Google Play" badge (Google Play can't be shown in an iframe:
// it sends X-Frame-Options: SAMEORIGIN, so the page links to it instead).
const PLAY_BADGE = 'https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png';

// What is on the Google Play developer page. Icons are in public/apps/<id>.png (192 px).
const APPS = [
  { id: 'io.ms.punjab.van', name: 'Desi Bus Simulator', tagline: 'Van Game', category: 'Simulation', game: true, text: 'Offline 3D bus driving game where everyone speaks Punjabi.' },
  { id: 'io.ms.desi.plane', name: 'Desi Plane', tagline: 'Flight Simulator', category: 'Simulation', game: true, text: 'Fly airplanes over Punjab in a 3D pilot game, with real Punjabi voices on board.' },
  { id: 'io.ms.alien.run', name: 'Alien Run', tagline: '3D Endless Runner', category: 'Arcade', game: true, text: 'Dash, jump and slide in an epic 3D endless runner. Fun offline chase game.' },
  { id: 'io.ms.moon.runner', name: 'Space Runner', tagline: 'Offline 3D Game', category: 'Arcade', game: true, text: 'Dash through the galaxy in a 3D space runner. Fun offline endless chase game.' },
  { id: 'io.ms.arrow.go', name: 'Arrow Puzzle', tagline: 'Tap Arrows Away', category: 'Puzzle', game: true, text: 'Tap arrows away and escape the maze. A relaxing logic puzzle you can play offline.' },
  { id: 'io.ms.math.iq.test', name: 'Math IQ', tagline: 'Mental Math Puzzles', category: 'Puzzle', game: true, text: 'Find the missing numbers to hit the target. Fun number puzzles and brain games.' },
  { id: 'io.ms.resume.reviewer', name: 'AI Resume Review', tagline: 'ATS Check', category: 'Productivity', text: 'Check your PDF resume or CV with AI: find weak spots and get ATS-friendly tips.' },
  { id: 'io.ms.ten.ai', name: 'CareerLab AI', tagline: 'Quiz Generator', category: 'Productivity', text: 'Make AI quizzes for your career field. Practise MCQs and prepare for job interviews.' },
  { id: 'io.ms.email.templates', name: 'Smart Mail', tagline: 'AI Email Templates', category: 'Productivity', text: 'AI email writer with reusable templates. Fill in the details and send in seconds.' },
  { id: 'io.ms.wishly', name: 'Birthday', tagline: 'Reminder & Calendar', category: 'Productivity', text: 'Birthday calendar with reminders and countdowns. Private and offline.' },
];

const playUrl = (id) => `https://play.google.com/store/apps/details?id=${id}`;

function AppCard({ app }) {
  return (
    <li className="home-card">
      <a className="home-card-head" href={playUrl(app.id)} target="_blank" rel="noopener noreferrer">
        <img src={`/apps/${app.id}.png`} alt="" width="72" height="72" loading="lazy" />
        <span>
          <strong>{app.name}</strong>
          <small>{app.tagline}</small>
        </span>
      </a>
      <span className="home-chip">{app.category}</span>
      <p>{app.text}</p>
      <a className="home-get" href={playUrl(app.id)} target="_blank" rel="noopener noreferrer">
        Get it on Google Play
      </a>
    </li>
  );
}

function Home() {
  useEffect(() => {
    document.title = `${DEVELOPER}: games and apps for Android`;
  }, []);

  const games = APPS.filter((a) => a.game);
  const apps = APPS.filter((a) => !a.game);

  return (
    <div className="home">
      <header className="home-hero">
        <p className="home-eyebrow">Android developer</p>
        <h1>{DEVELOPER}</h1>
        <p className="home-lead">Fun 3D games and AI-powered tools for Android, made to be simple, light and quick to start.</p>
        <ul className="home-stats">
          <li><b>{APPS.length}</b> on Google Play</li>
          <li><b>{games.length}</b> games</li>
          <li><b>{apps.length}</b> apps</li>
        </ul>
        <a className="home-badge" href={DEVELOPER_URL} target="_blank" rel="noopener noreferrer">
          <img src={PLAY_BADGE} alt="Get it on Google Play" width="646" height="250" />
        </a>
      </header>

      <main className="home-main">
        <section>
          <h2>Games</h2>
          <p className="home-section-lead">3D driving, flying and running games, and puzzles for your brain. Many of them play offline.</p>
          <ul className="home-grid">
            {games.map((app) => <AppCard key={app.id} app={app} />)}
          </ul>
        </section>

        <section>
          <h2>Apps</h2>
          <p className="home-section-lead">AI helpers for your career and email, and a private birthday calendar.</p>
          <ul className="home-grid">
            {apps.map((app) => <AppCard key={app.id} app={app} />)}
          </ul>
        </section>

        <section className="home-about">
          <h2>About us</h2>
          <p>
            {DEVELOPER} builds free Android games and apps. We keep them small and fast, ask only for the
            permissions they need, and keep your data on your device wherever we can. Every app links to its
            own privacy policy from its Google Play page.
          </p>
          <p>
            Questions, ideas or a bug to report? Write to us at <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
          </p>
          <a className="home-all" href={DEVELOPER_URL} target="_blank" rel="noopener noreferrer">
            See all our apps on Google Play
          </a>
        </section>
      </main>

      <footer className="home-footer">
        <p>© {new Date().getFullYear()} {DEVELOPER}</p>
        <p>Google Play and the Google Play logo are trademarks of Google LLC.</p>
      </footer>
    </div>
  );
}

export default Home;
